import styled from 'styled-components'

export const MobileHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px 0;
  margin-bottom: 18px;

  .logo-link {
    display: flex;
    align-items: center;
  }
`
